












































import Vue from "vue";
import Component from "vue-class-component";
import Map from "@/components/map.vue";

@Component({
  components: {
    'gmap' : Map,
  },
})
export default class Layout extends Vue {
  private goSocial(num: number){
    if (num == 1){
      window.location.href = 'https://www.facebook.com/SazgarBAIC/';
    }
    if (num == 2){
      window.location.href = 'https://twitter.com/GlobalHaval';
    }
    if (num == 3){
      window.location.href = 'https://www.instagram.com/baicpakistan/';
    }
    if (num == 4){
      window.location.href = 'https://www.youtube.com/channel/UCoSAAm8URyeUNDOAMySL-Ow';
    }
  }

}
